import React, { useState } from "react";
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import bktImg from "../../../../assets/qrcode/bg-bhaktapur.jpg";
import bktImg2 from "../../../../assets/qrcode/bhaktapur1.jpg";
import bktImg3 from "../../../../assets/qrcode/bhaktapur2.jpg";
import bktImg4 from "../../../../assets/qrcode/bhaktapur3.jpg";

const items = [
  {
    src: bktImg,
    altText: 'First Slide',
    // caption: 'This is the first slide'
  },
  {
    src: bktImg2,
    altText: 'Second Slide',
    // caption: 'This is the second slide'
  },
  {
    src: bktImg3,
    altText: 'Third Slide',
    // caption: 'This is the third slide'
  },
  {
    src: bktImg4,
    altText: 'fourth Slide',
    // caption: 'This is the fourth slide'
  }
];

export const Home = (props) => {
  const [aminating,setAnimating]=useState()
  const [activeIndex, setActiveIndex] = React.useState(0);
  const next = () => {
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    setActiveIndex(newIndex);
  };

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
        // style={{height:"100px"}}
      >
        <img src={item.src} alt={item.altText} className="d-block w-100" style={{height:"90vh",  objectFit: "cover"
}}/>
        <div className="carousel-caption">
          <h5>{item.caption}</h5>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div id="home">
      <Carousel activeIndex={activeIndex} next={next} previous={previous}>
        <CarouselIndicators
          items={items}
          activeIndex={activeIndex}
          onClickHandler={goToIndex}
        />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
  
    </div>
  );
};

